var _templateObject, _templateObject2;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { styled, css } from '@creditas-ui/system';
import { variant, mixins } from '@creditas-ui/utilities';
import { Box } from '@creditas-ui/layout';
var base = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  border: none;\n"])));

var colors = _ref => {
  var {
    theme: {
      skeleton
    }
  } = _ref;
  return variant({
    prop: 'color',
    variants: {
      light: skeleton('color.light'),
      dark: skeleton('color.dark')
    }
  });
};

var SkeletonElement = styled(Box)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n"])), base, mixins.shimmer, colors);
export { SkeletonElement };
//# sourceMappingURL=Skeleton.style.js.map